import { useState, useCallback, useMemo, useEffect } from 'react';
import { Map, Set } from 'immutable';

export default function useListParams({
  sort = 'createdAt',
  order = 'desc',
  page = 1,
  search = '',
  filters = new Map(),
  selected = new Set(),
} = {}) {
  const [_sort, setSort] = useState(sort);
  const [_order, setOrder] = useState(order);
  const [_page, setPage] = useState(page);
  const [_search, setSearch] = useState(search);
  const [_filters, setFilters] = useState(filters);
  const [_selected, setSelected] = useState(selected);
  const getSort = useCallback(() => _sort, [_sort]);
  const getOrder = useCallback(() => _order, [_order]);
  const getPage = useCallback(() => _page, [_page]);
  const getSearch = useCallback(() => _search, [_search]);
  const getFilters = useCallback(() => _filters, [_filters]);
  const getSelected = useCallback(() => _selected, [_selected]);
  const clear = useCallback(() => {
    setSort(sort);
    setOrder(order);
    setPage(page);
    setSearch(search);
    setFilters(filters);
    setSelected(selected);
  }, []);
  const data = useMemo(() => ({
    sort: _sort,
    order: _order,
    page: _page,
    search: _search,
    filters: _filters.toJS(),
  }), [_sort, _order, _page, _search, _filters]);

  useEffect(() => {
    setPage(page);
  }, [_search, _filters]);

  return {
    getSort,
    setSort,
    getOrder,
    setOrder,
    getPage,
    setPage,
    getSearch,
    setSearch,
    getFilters,
    setFilters,
    getSelected,
    setSelected,
    clear,
    data,
  };
}
